import { mountSvelteComponents } from '../mount.js';
function main(){
  if(true){
      document.getElementById('main').insertAdjacentHTML(
        'beforeend',
        '<div class="view" data-svelte-component="bad_study" data-props="{}" />'
      );
      mountSvelteComponents();
  }
  else{
    setTimeout( main, 500 );
  }
}

main();

